import styled from "styled-components";

export const Section = styled.section`
  padding-top: ${({paddingTop}) => paddingTop || '120px'};
  padding-bottom: ${({paddingBottom}) => paddingBottom || '120px'};
  text-align: ${({textAlign}) => textAlign || 'none'}
`